import type { FC } from 'react'

import cn from 'classnames'

import type { TTextInfoProps } from '@web/shared/components/text-info/text-info.type'

import css from './text-info.module.css'

const TextInfo: FC<TTextInfoProps> = ({
  children,
  className,
  mode = 'default',
  ...props
}) => (
  <p
    className={cn(css.textInfo, className, { [css.error]: mode === 'error' })}
    {...props}
  >
    {children}
  </p>
)

export default TextInfo
